import { useInfiniteQuery } from '@tanstack/react-query'
import { User } from 'firebase/auth'
import { getAllRequests, getRequests } from 'api'

const TAKE = 12

interface Params {
  deviceId: string
  sourceType: 'image' | 'text'
  user: User | null
}

const useInfiniteFetchRequests = (params: Params) => {
  const { deviceId, sourceType, user } = params
  return useInfiniteQuery(
    ['infinite-requests', params],
    async ({ pageParam: page = 1 }) => {
      if (user) {
        const token = await user.getIdToken()
        return getAllRequests(token, sourceType, page, TAKE)
      }
      return getRequests(deviceId, sourceType, page, TAKE)
    },
    {
      getNextPageParam: (lastPage, allPages) => {
        if (lastPage.length < TAKE) return undefined
        return allPages.length + 1
      },
    },
  )
}

export default useInfiniteFetchRequests
